<template>
  <client-only>
    <div v-if="post.front_container === 'premium'" class="badge"></div>
  </client-only>
</template>

<script setup lang="ts">
import { Post } from "@/types/Post";

interface _Props {
  post?: Post;
}

const { post } = withDefaults(defineProps<_Props>(), {
  post: {},
});
</script>

<style scoped lang="scss">
div.badge {
  position: absolute;
  left: -45px;
  top: 45px;
  width: 73px;
  height: 48px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url("/img/btn/btn-premium.png");

  @media (max-width: 768px) {
    left: -15px;
    top: 35px;
  }
}
</style>
